import { useSavedViews } from "./useSavedViews";

/** Pinned shortcuts (a record or a list) kept per person; they show in the Home panel */
export function usePins() {
  const { views, save, remove, reload } = useSavedViews("pin");
  const pins = views.map((v) => ({ id: v.id, label: String(v.config.label || v.name), to: String(v.config.to || "/") }));
  const find = (to: string) => pins.find((p) => p.to === to);
  const toggle = async (to: string, label: string) => {
    const existing = find(to);
    if (existing) await remove(existing.id);
    else await save(to, { to, label });
  };
  return { pins, isPinned: (to: string) => !!find(to), toggle, reload };
}
